import { AppBar, Box, Link, Toolbar } from "@mui/material";
import cplLogo from "../../assets/images/cpl-logo.png";

const Header = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        boxShadow: "none",
        bgcolor: "white", // Blue color matching the screenshot
        borderBottom: "1px solid #E0E0E0", // Light gray border at the bottom
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: "100%",
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: 3,
        }}
      >
        {/* Logo Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            px: 2,
            py: 2,
            height: "88px",
          }}
        >
          <Link
            href="/"
            underline="none"
            color="inherit"
            style={{ height: "100%", width: "auto" }}
          >
            <img
              src={cplLogo}
              alt="3CE Logo"
              style={{ height: "100%", width: "auto" }}
            />
          </Link>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
